// 9fbef606107a605d69c0edbcd8029e5d
import addCustomerGiftCard from '@tcp/core/src/queries/addCustomerGiftCard.query.graphql';
import logger from '@tcp/core/src/utils/loggerInstance';
import { executeStatefulAPICall, executeStatefulGraphQLQuery } from '../../handler';
import endpoints from '../../endpoints';

export const getCardListApi = () => {
  const payloadData = {
    webService: endpoints.getCardList,
    header: {
      isRest: true,
    },
  };
  return executeStatefulAPICall(payloadData)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const addGiftCardApi = (payload) => {
  const reqObject = {
    addCustomerGiftCardGiftCardRequestDto: {
      c_giftCardNumber: payload.giftCardNumber,
      c_giftCardPin: payload.cardPin,
      recaptureResponse: payload.recaptchaToken,
    },
  };

  return executeStatefulGraphQLQuery({
    query: addCustomerGiftCard,
    variables: reqObject,
    type: 'mutation',
  })
    .then((resp) => {
      return resp;
    })
    .catch((error) => {
      logger.error(error);
      throw error;
    });
};
